import React, { Component } from 'react'
import { Form, FormField, TextBox, LinkButton, ComboBox, MaskedBox, DateBox, Panel, Messager, GridColumn, DataGrid, Dialog, NumberBox } from 'rc-easyui';
import { getCookie, getAccessToken } from '../../../helpers/cookieHelper';
import { API_URL, BASE_URL } from "../../../constants";
import { Button } from 'reactstrap';
// import { autoDissaperAction } from "../../../helpers/index";
import { isEmpty } from "../../../helpers";
import { getPriorityID, getProjectID, getTicketTypeId, getTicketStatusId, getAssigneId } from './TicketAPI'
import { getUserId } from '../../../helpers/AuthHelper';

const axios = require("axios");

export default class UpdateTicket extends Component {
  constructor(props) {
    super(props)
    this.childRef = React.createRef()
    this.state = {
      Ticket: {
        summary: "",
        description: "",
        linkedTicket: "",
        projectId: "",
        assigneeId: "",
        priorityId: "",
        ticketTypeId: "",
        statusId: "",
        enabled: '',
        privateTicket: '',
        estimate: "",
        expectedCompletionDateAd: '',
        createdBy: getUserId(),
        workLog: "",
        comments: "",
      },

      id: null,
      worklogData: [],
      commentData: [],
      transitionData: [],
      ticketData: [],
      projectList: [],
      priorityList: [],
      ticketTypeList: [],
      StatusList: [],
      userList: [],
      rules: {
        summary: ['required'],
        description: ['required'],
        linkedTicket: ['required'],
        // estimate: ['required'],
        workLog: ['required'],
        comments: ['required'],
      },
      enableStatus: [
        { value: true, text: "Active" },
        { value: false, text: "Inactive" }
      ],
      privateTicketStatus: [
        { value: 1, text: "True" },
        { value: 0, text: "False" }

      ],

      esti: {
        estimateHour: "",
        estimateMinute: ""
      },

      permissions: [],
      view: [],
      pageArray: [],

      isLoading: false,
    }


  }

  componentDidMount = async () => {
    var data = getCookie('permission');

    this.dlg.close()
    this.work.close()
    this.tra.close()
    let search = window.location.search

    let Id = new URLSearchParams(search).get("id")

    await this.getTicketDetailByID(Id);
    await this.getWorklogByTicketId(Id);
    await this.getCommentByTicketId(Id);
    await this.getTransitionByTicketId(Id);


    this.setState({
      permissions: JSON.parse(data),
      id: Id,
      projectList: await getProjectID(),
      priorityList: await getPriorityID(),
      ticketTypeList: await getTicketTypeId(),
      StatusList: await getTicketStatusId(),
      userList: await getAssigneId(),
      isLoading: false
    })
  }





  convertTimeStampToTime = (timeStamp) => {
    const date = new Date(timeStamp);
    let year = date.getFullYear(),
      month = date.getMonth(),
      day = date.getDate();
    return `${year}/${month}/${day}`
  }


  handleUpdate = async () => {
    let token = getCookie("access_token");
    let tokenType = getCookie("token_type");
    let form = Object.assign({}, this.state.Ticket);
    let apiUrl = `${API_URL}api/saveticket`;
    let headerConfig = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `${tokenType} ${token}`,
      },
    };
    this.form.validate(async (errors) => {
      if (isEmpty(errors)) {
        if (token != null) {
          //Access Token Available
          this.setState({
            isLoading: true,
          });
          //console.log(form);
          axios
            .put(apiUrl, form, headerConfig)
            .then((response) => {

              if (response.status === 200) {
                this.setState({
                  isLoading: false,
                });
                if (response.data.status) {
                  this.messager.alert({
                    title: "Success",
                    msg: response.data.message,
                    icon: "info",
                    reload: true,
                  });
                  window.location.href = `${BASE_URL}ticketing-detail-page`
                } else {
                  this.messager.alert({
                    title: "Error",
                    msg: response.data.message,
                  });
                }
              } else {
                this.messager.alert({
                  title: "Error",
                  msg: "Uncaught Error",
                  reload: false,
                });
              }
            })
            .catch((error) => {
              //console.log("error",error);
              this.setState({
                isLoading: false,
              });
              var response = error["response"];
              if (response !== undefined) {
                if (response.status === 400) {
                  var message = "";
                  response.data.errors.forEach((row, i) => {
                    message +=
                      "<p style='margin-bottom:3px;'>" +
                      row.field.toUpperCase() +
                      " " +
                      row.defaultMessage +
                      "</p>";
                  });
                  //console.log(message);
                  this.messager.alert({
                    title: "Error",
                    msg: message,
                    reload: false,
                  }); // Backend Validation Error ie.400
                } else {
                  this.messager.alert({
                    title: "Error",
                    msg: "UnCaught Error",
                    reload: false,
                  }); // Uncaught Backend Error ie.500 eyc.
                }
              } else {
                this.messager.alert({
                  title: "Error",
                  msg: "Internal Server Error",
                  reload: false,
                }); // Caused due to syntax error in front end
              }
            });
        } else {
          //Access Token Expired.
          //Generate new Access Token using Refresh Token.
          const resp = await getAccessToken();
          if (resp) {
            this.handleUpdate();
          }
        }
      } else {
        //alert("Front End Form Validaion ");
        this.messagerConform.alert({
          title: "Error",
          icon: "error",
          msg: "Please fill required field.",
          reload: false,
        });
      }
    });

  }





  getTicketDetailByID = async (id) => {
    let erp_access_token = getCookie('access_token')
    let erp_token_type = getCookie('token_type')
    let headerConfig = {
      headers: {
        authorization: erp_token_type + ' ' + erp_access_token,
        'Content-Type': 'application/json',
      },
    }
    if (erp_access_token != null) {
      this.setState({
        isLoading: true,
      })
      let url = API_URL + `api/getticketbyid?id=${id}`;
      axios.get(url, headerConfig)
        .then((response) => {

          if (response.status === 200) {
            var data = response.data.object
            var ticketData = {
              id: data.ticketId,
              summary: data.summary,
              description: data.description,
              linkedTicket: data.linkedTicket,
              projectId: data.projectId,
              assigneeId: data.assigneeId,
              priorityId: data.priorityId,
              ticketTypeId: data.ticketTypeId,
              statusId: data.statusId,
              enabled: data.enabled,
              privateTicket: data.privateTicket,
              estimate: data.estimate,
              expectedCompletionDateAd: data.expectedCompletionDateAd,
              createdBy: data.createdBy
            }

            this.setState({
              Ticket: ticketData
            })


          } else {

            return []
          }
        })
        .catch((error) => {

          return []


        })
    } else {
      const resp = await getAccessToken()
      if (resp) {
        this.getTicketDetailByID()
      }
    }

  }



  getWorklogByTicketId = async (id) => {
    let erp_access_token = getCookie('access_token')
    let erp_token_type = getCookie('token_type')
    let headerConfig = {
      headers: {
        authorization: erp_token_type + ' ' + erp_access_token,
        'Content-Type': 'application/json',
      },
    }
    if (erp_access_token != null) {
      this.setState({
        isLoading: true,
      })
      let url = API_URL + `api/getworklogbyticketid?id=${id}`;
      axios.get(url, headerConfig)
        .then((response) => {

          if (response.status === 200) {
            let tempObj = response.data.object
            tempObj = tempObj.map(data => {
              let time = this.convertTimeStampToTime(data.createdIn);
              data['createdIn'] = time
              return data
            })


            this.setState({
              worklogData: tempObj
            })


          } else {

            return []
          }
        })
        .catch((error) => {

          return []


        })
    } else {
      const resp = await getAccessToken()
      if (resp) {
        this.getWorklogByTicketId()
      }
    }

  }


  getTransitionByTicketId = async (id) => {
    let erp_access_token = getCookie('access_token')
    let erp_token_type = getCookie('token_type')
    let headerConfig = {
      headers: {
        authorization: erp_token_type + ' ' + erp_access_token,
        'Content-Type': 'application/json',
      },
    }
    //   console.log(erp_access_token)
    if (erp_access_token != null) {
      this.setState({
        isLoading: true,
      })
      let url = API_URL + `api/gettransitionbyticketid?id=${id}`;
      axios.get(url, headerConfig)
        .then((response) => {
  
          if (response.status === 200) {

            let tempObj = response.data.object[0]
            let time = this.convertTimeStampToTime(tempObj.createdIn);
            tempObj['createdIn'] = time
       
            let tempArr = [];
            tempArr.push(tempObj)

            this.setState({
              transitionData: tempArr
            })


          } else {

            return []
          }
        })
        .catch((error) => {

          return []


        })
    } else {
      const resp = await getAccessToken()
      if (resp) {
        this.getTransitionByTicketId()
      }
    }

  }


  getCommentByTicketId = async (id) => {

    let erp_access_token = getCookie('access_token')
    let erp_token_type = getCookie('token_type')
    let headerConfig = {
      headers: {
        authorization: erp_token_type + ' ' + erp_access_token,
        'Content-Type': 'application/json',
      },
    }
    //   console.log(erp_access_token)
    if (erp_access_token != null) {
      this.setState({
        isLoading: true,
      })
      let url = API_URL + `api/getcommentsbyticketid?id=${id}`;
      axios.get(url, headerConfig)
        .then((response) => {
   
          if (response.status === 200) {

            let tempObj = response.data.object
            tempObj = tempObj.map(data => {
              let time = this.convertTimeStampToTime(data.createdIn);
              data['createdIn'] = time
              return data
            })



            this.setState({
              commentData: tempObj
            })
          


          } else {

            return []
          }
        })
        .catch((error) => {

          return []


        })
    } else {
      const resp = await getAccessToken()
      if (resp) {
        this.getCommentByTicketId()
      }
    }

  }



  render() {
    const {
      Ticket,
      handleInput,
      projectList,
      priorityList,
      ticketTypeList,
      StatusList,
      enableStatus,
      privateTicketStatus,
      operation,
      rules,
      commentData,
      transitionData,
      worklogData, userList
    } = this.state;
    const { isLoading } = this.state;

    return (

      <div>

        <Panel title='Ticket Detail Info' bodyStyle={{ padding: 20 }} style={{ width: '100%', padding: 10 }}>
          <Messager
            ref={(ref) => (this.messager = ref)}
            showHeader={false}
            borderType='none'
            content={({ title, msg, buttons, reload }) => (
              <div className='alert-content'>
                <h3>{title}</h3>
                <div
                  style={{ marginBottom: 5 }}
                  dangerouslySetInnerHTML={{ __html: msg }}
                ></div>
                <div className='m-buttons'>
                  {buttons.map((button, index) => (
                    <LinkButton
                      key={index}
                      text={button.text}
                      onClick={() => {
                        this.messager.close(button);
                        if (reload) {
                          window.location.reload();
                        }
                      }}
                    />
                  ))}
                </div>
              </div>
            )}
          />
          <Messager ref={ref => this.messagerConform = ref}></Messager>

          <div
            className='loadingmodel'
            style={{ display: isLoading ? "block" : "none" }}
          ></div>

          <Form
            ref={ref => this.form = ref}
            style={{ maxWidth: '100%' }}
            model={Ticket}
            labelWidth={200}
            labelAlign="left"
            labelPosition='top'
            onChange={handleInput}
            rules={rules}>
            <div className='row'>
              <div className='col-md-6'>
                <FormField name="summary" label="Summary:">
                  <TextBox value={Ticket.summary} multiline style={{ height: 80 }}></TextBox>
                </FormField>
              </div>
              <div className='col-md-6'>
                <FormField name="description" label="Description:">
                  <TextBox value={Ticket.description} multiline style={{ height: 80 }}></TextBox>
                </FormField>
              </div>
            </div>

            <div className='row'>
              <div className='col-md-3'>
                <FormField name="linkedTicket" label="Linked Ticket:">
                  <TextBox value={Ticket.linkedTicket}></TextBox>
                </FormField>
              </div>

              <div className='col-md-3'>
                <FormField name="privateTicket" label="Private Ticket:">
                  <ComboBox style={{ width: "100%" }} data={privateTicketStatus} value={Ticket.privateTicket}></ComboBox>
                </FormField>

              </div>
              <div className='col-md-3'>
                <FormField name="projectId" label="Project Name:">
                  <ComboBox
                    style={{ width: "100%" }}
                    data={projectList}
                    value={Ticket.projectId}
                    valueField="id"
                    textField="projectName"

                  />
                </FormField>
              </div>
              <div className='col-md-3'>
                <FormField name="assigneeId" label="Assignee:">
                  <ComboBox
                    style={{ width: "100%" }}
                    data={userList}
                    value={Ticket.assigneeId}
                    valueField="id"
                    textField="username"

                  />
                </FormField>
              </div>
            </div>

            <div className='row'>
              <div className='col-md-3'>
                <FormField name="priorityId" label="Priority Name:" >
                  <ComboBox
                    style={{ width: "100%" }}
                    data={priorityList}
                    value={Ticket.priorityId}
                    valueField="id"
                    textField="priority"

                  />
                </FormField>
              </div>

              <div className='col-md-3'>
                <FormField name="ticketTypeId" label='Ticket Type:'>
                  <ComboBox
                    style={{ width: "100%" }}
                    data={ticketTypeList}
                    value={Ticket.ticketTypeId}
                    valueField="id"
                    textField="ticketType"

                  />
                </FormField>
              </div>
              <div className='col-md-3'>
                <FormField name="statusId" label="Ticket Status:">
                  <ComboBox
                    style={{ width: "100%" }}
                    data={StatusList}
                    value={Ticket.statusId}
                    valueField="id"
                    textField="status"

                  />
                </FormField>
              </div>
              <div className='col-md-3'>
                <FormField name="enabled" label="Status:">
                  <ComboBox style={{ width: "100%" }} data={enableStatus} value={Ticket.enabled}></ComboBox>
                </FormField>
              </div>
            </div>
            <div className='row'>
              <div className='col-md-3'>
                <FormField name="estimate" label="Estimate Time:">
                  <NumberBox value={Ticket.estimate} placeholder="....hours and ....minutes"></NumberBox>
                </FormField>
              </div>
              <div className='col-md-3'>
                <FormField name="expectedCompletionDateAd" label="Expected Completion Date in AD:">
                  <MaskedBox inputId="m2" mask="9999-99-99" value={Ticket.expectedCompletionDateAd}    ></MaskedBox>
                  {/* <DateBox                                      
                                      format='yyyy-MM-dd'
                                      value={Ticket.expectedCompletionDateAd}                                      
                                     panelStyle={{ width: 250, height: 300, margin: "auto" }}                                    
                                     ></DateBox> */}

                </FormField>
              </div>
              <div className='col-md-3'>
                <FormField name="workLog" label="Worklog:">
                  {/* <TextBox value={Ticket.workLog}
                    placeholder="....hours and ....minutes"
                  ></TextBox> */}
                  <NumberBox value={Ticket.workLog}></NumberBox>
                </FormField>
              </div>
            </div>





            <div className='row'>
              <div className='col-md-6'>
                <FormField name="comments" label="Comments:">
                  <TextBox value={Ticket.comments} multiline style={{ height: 80, width: 382 }} ></TextBox>
                </FormField>
              </div>
            </div>


            <div className="row">
              <div className="col">
                <LinkButton onClick={() => this.dlg.open()}>View Comment</LinkButton>
                <Dialog

                  title="Comments"
                  style={{ width: '400px', height: '300px', margin: 'auto', display: "inline-block" }}
                  modal={this.state.commentData}
                  ref={ref => this.dlg = ref}
                // draggable
                // resizable

                >
                  <DataGrid data={commentData} style={{ height: 250 }}>
                    <GridColumn field="createdIn" title="Date"></GridColumn>
                    <GridColumn field="id" title="Commented By"></GridColumn>
                    <GridColumn field="comments" title="Comment" sortable></GridColumn>



                  </DataGrid>
                </Dialog>
              </div>


              <div className="col">
                <LinkButton onClick={() => this.work.open()} style={{ marginLeft: -300 }}>View WorkLog</LinkButton>
                <Dialog
                  title="Work Logs"
                  style={{ width: '400px', height: '300px', margin: 'auto' }}
                  modal={this.state.worklogData}
                  ref={ref => this.work = ref}
                >

                  <DataGrid data={worklogData} style={{ height: 250 }}>
                    <GridColumn field="createdIn" title="Date"></GridColumn>
                    <GridColumn field="userName" title="Log By"></GridColumn>
                    <GridColumn field="workLog" title="Work Log"></GridColumn>



                  </DataGrid>
                </Dialog>

              </div>
              <div className="col">
                <LinkButton onClick={() => this.tra.open()} style={{ marginLeft: -600 }}>View Transition</LinkButton>
                <Dialog
                  title="Transaction"
                  style={{ width: '400px', height: '300px', marginLeft: 'auto' }}
                  modal={this.state.transitionData}
                  ref={ref => this.tra = ref}
                >
                  <DataGrid data={transitionData} renderDetail={this.renderDetailT} style={{ height: 250 }}>

                    <GridColumn field="createdIn" title="Date"></GridColumn>
                    <GridColumn field="userName" title="Transition By"></GridColumn>
                    <GridColumn field="status" title="Status"></GridColumn>

                  </DataGrid>
                </Dialog>


              </div>
            </div>
            <br />
            <div className='text-center'>
              <Button
                color='primary'
                disabled={isLoading ? true : false}
                onClick={
                  this.handleUpdate
                }
                style={{ marginRight: 20 }}
              >
                {operation === "Add" ? "Save" : "Update"}
              </Button>
              <Button color='danger' onClick={this.props.formClear}>
                Cancel
              </Button>
            </div>
          </Form>
        </Panel>
      </div>
    )
  }
}




